import { z } from 'zod'

import { organizationMemberSchema } from './organizationMember'
import {
  organizationRelationshipPermissionSchema,
  organizationRelationshipSchema,
} from './organizationRelationship'
import { organizationPermissionSchema } from './permission'

export const organizationPermissionAuditPayloadSchema = z.object({
  members: z.array(
    z.object({
      member: organizationMemberSchema,
      permissions: z.array(organizationPermissionSchema),
    })
  ),
  promoters: z.array(
    z.object({
      relationship: organizationRelationshipSchema,
      permissions: z.array(organizationRelationshipPermissionSchema),
    })
  ),
  venuesById: z.record(z.string(), z.object({ name: z.string() })),
})

export const organizationPermissionAuditResponseSchema = z.object({
  data: organizationPermissionAuditPayloadSchema,
})

/** GET permission-audit: no query/body fields today (path `:id` validated outside requestSchema). */
export const organizationPermissionAuditRequestSchema = z.object({})
